import styled, { css } from 'styled-components';
import {
  ImageSearchOutlined,
} from '@mui/icons-material';

import FileSelectButton from '../../../../../../components/FileSelectButton';
import colors from '../../../../../../styles/colors';

const HeroImageContainer = styled.div`
  display: flex;
  margin-top: 20px;
`;

const descriptionStyles = css`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${colors.shades.gamma9};
`;

const HeroImageDescriptionContainer = styled.div`
  ${descriptionStyles};
  margin-left: 20px;
  max-width: 370px;
`;

const HeroImageDescription = styled.div``;

const HeroImageTipsDescription = styled.div`
  margin-top: 16px;
`;

const HeroImageUploader = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
`;

const HeroImageWrapper = styled.div`
  width: 300px;
  aspect-ratio: 4/3;
  display: flex;
  background-color: ${colors.shades.gamma1};
  overflow: hidden;
`;

const StyledPreview = styled.img`
  width: 100%;
  height: auto;
`;

const StyledEditIcon = styled.div`
  background-color: ${colors.base.alpha};
  color: ${colors.base.beta};
  border-radius: 50%;
  width: 35px;
  height: 35px;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items:  center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.25s;
`;

const StyledFileSelectButton = styled(FileSelectButton)`
  position: relative;
  width: 100%;

  &:hover > ${StyledEditIcon} {
    opacity: 1;
  }
`;

const StyledImageSearch = styled(ImageSearchOutlined)`
  color: ${colors.base.beta};
  width: 65px;
  height: auto;
`;

const SaveButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
`;

export {
  HeroImageContainer,
  HeroImageDescriptionContainer,
  HeroImageDescription,
  HeroImageUploader,
  HeroImageWrapper,
  StyledPreview,
  StyledEditIcon,
  StyledFileSelectButton,
  StyledImageSearch,
  HeroImageTipsDescription,
  SaveButtonContainer,
};
